import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filesize',
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  private readonly units: string[] = ['bytes', 'KB', 'MB', 'GB', 'TB'];

  transform(size = 0, precision = 2): string | null {
    if (!isFinite(size)) {
      return null;
    }

    let unitIndex = 0;

    while (size > 1024 && unitIndex < this.units.length - 1) {
      size /= 1024;
      unitIndex++;
    }
    return `${size.toFixed(precision)} ${this.units[unitIndex]}`;
  }
}
